/**
 * all mock data
 */
import Mock from 'mockjs'
import cache from '../common/cache'
import url from '../common/url'
// 二手车
import './used/list'
import './used/check'
import './used/detail'

// 车况
import './conditionReport'

// 养修预约
import './appointment/list'

// 今日到店
import './cus/day'
import './cus/info'
import './cus/pre'

// 报表
import './report/index'

// 优惠券
import './cou/check'
import './cou/detail'

// 礼品卡
import './gift/index'

// 短信回复
import './sms/reply'

// 车辆道闸
import './barriergate/checkList'
import './barriergate/allList'
import './barriergate/createFlow'
import './barriergate/flowDetail'
import './barriergate/trajectoryDetail'

// 二手车项目
import './usedcar/carList'
import './usedcar/carDetail'
import './usedcar/previewer'
import './usedcar/operate'
import './usedcar/submit'
import './usedcar/storeVehicle'
import './usedcar/rater'
import './usedcar/inquiry' // 查博士历史车况
import './auction/vehicleManage'
import './auction/basicDetail'

// 车信息
import './car/carInfo'

// 车信息
import './auction/basic'
// 编辑
import './auction/brief'
// 上传照片
import './auction/photo'
// 出价信息
import './auction/offer'
// 车商信息
import './auction/detail'
// 获取指定车型详细参数
import './auction/extinfo'
// 车辆信息
import './auction/carInfo/basic' // 基本信息
import './auction/carInfo/config' // 配置信息

// 获取检测信息列表
import './auction/inspections'

// 按日期查询拍卖场次
import './auction/sessions'

// 拍卖管理订单详情
import './auction/orderDetail'
// 已收款
import './auction/paid'
// 已收款
import './auction/orderClose'

// 提交拍卖信息
import './auction/confirm'

// 车辆二维码
import './carqrcode/carqrcodeinfo'

// 车辆进出数据
import './dataAnalysis/carVisit'

// 销售数据统计
import './dataAnalysis/saleAnalysis'

// 到店客户数据
import './dataAnalysis/shopCustomers'

// 销售顾问
import './dataAnalysis/salesConsultant'

// DCC专员跟进
import './dataAnalysis/dccFollowUp'
// 二手车统计
import './dataAnalysis/usedcar'
// 权限相关
import './auth/index'

/* 销售管理 */

// 经理平台
import './salemanage/manage'
// 员工平台
import './salemanage/staff'
// 车型相关
import './salemanage/car'
// 我的客户
import './salemanage/carregisters'
// 优惠卷
import './couponCheck/check'
// 网站定制
import './customized/index'

// 门店信息
import './store/index'

// 询价列表
import './inquiry/inquiryList'
// 询价信息
import './inquiry/inquiryInfo'
// 车商列表
import './inquiry/carStore'
// 发起询价
import './inquiry/inquiry'

// 保险模块 - 报价信息
import './insurance/quoteInfo'
import './insurance/updateInfo'

// ----------撮合管理-------
import './auction/match'
import './auction/matchSelect'

// ----------报废、零售、批售出库
// 车辆出库
import './auction/outBound'
import './outbound/list'

// 车辆到店登记
import './carRegister/index'

// 过户模块
import './transfer/index'

// 排行榜模块
import './rank/index'

// 客餐排队取号
import './tool/guestMeals'

// 我的顾客

// mock 开关
let mock = url.getSearch().mock
if (mock === '1') {
  cache.setSessionData('mock', true)
} else if (mock === '2') {
  cache.setSessionData('mock', false)
}
Mock.setup({
  timeout: 400
})
